module.exports = __webpack_public_path__ + "img/logo-3.e7d542e0.png";